import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { FileText, GitBranch, Layout } from "lucide-react";
import AdminStepsEditor from "./AdminStepsEditor";
import AdminSectionsEditor from "./AdminSectionsEditor";
import AdminDocumentTypesEditor from "./AdminDocumentTypesEditor";
import { useAdminSessionState } from "./useAdminSessionState";

const AdminDocuments = ({ userId, onDirtyChange }) => {
  const [activeSubTab, setActiveSubTab] = useAdminSessionState(`admin:${userId}:documentsTab`, 0);
  const [hasUnsavedDocumentChanges, setHasUnsavedDocumentChanges] = React.useState(false);

  React.useEffect(() => {
    onDirtyChange?.(hasUnsavedDocumentChanges);
  }, [hasUnsavedDocumentChanges, onDirtyChange]);
  React.useEffect(() => () => onDirtyChange?.(false), [onDirtyChange]);

  const handleSubTabChange = (event, newValue) => {
    if (hasUnsavedDocumentChanges && !window.confirm('You have unsaved changes. Discard them?')) return;
    setActiveSubTab(newValue);
  };

  return (
    <div className="standard-container">
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <h3 style={{ margin: 0 }}>Document Builder</h3>
        </Box>
        <Tabs
          value={activeSubTab}
          onChange={handleSubTabChange}
          aria-label="document builder tabs"
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab 
            icon={<FileText size={16} />} 
            iconPosition="start" 
            label="Document" 
          />
          <Tab 
            icon={<GitBranch size={16} />} 
            iconPosition="start" 
            label="AI Steps" 
          />
          <Tab 
            icon={<Layout size={16} />} 
            iconPosition="start" 
            label="Document Sections" 
          />
        </Tabs>
      </Box>

      {activeSubTab === 0 && <AdminDocumentTypesEditor userId={userId} onDirtyChange={setHasUnsavedDocumentChanges} />}
      {activeSubTab === 1 && <AdminStepsEditor />}
      {activeSubTab === 2 && <AdminSectionsEditor />}
    </div>
  );
};

export default AdminDocuments;
